import { Component, input } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
	selector: 'app-summary-box-item',
	templateUrl: 'summary-box-item.component.html',
	standalone: true,
	imports: [TranslocoModule],
	host: {
		class: 'contents',
	},
})
export class SummaryBoxItemComponent {
	title = input<string>();
	value = input<unknown>();
}
